exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".gnav-links-a:hover{-webkit-transition:all .15s;transition:all .15s}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/navigation/NavigationStandard1/src/components/navigation/NavigationStandard1/NavigationStandard1.l.scss"],"names":[],"mappings":"AAII,oBAEI,4BAA6B,AAC7B,mBAAqB,CACtB","file":"NavigationStandard1.l.scss","sourcesContent":["@import '~scss/variables';\n\n.gnav {\n  &-links {\n    &-a {\n      &:hover {\n        -webkit-transition: all 150ms;\n        transition: all 150ms;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/navigation/NavigationStandard1/NavigationStandard1.l.scss
// module id = 1249
// module chunks = 59